// extracted by mini-css-extract-plugin
export var searchHeader = "_s-0";
export var searchHeaderDark = "_s-1";